// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-width {\r\n    width: 80%;\r\n}\r\n\r\n.error-description {\r\n    font-size: 120%;\r\n    text-align: center;\r\n}\r\n\r\n.font-heading {\r\n    font-size: 160%;\r\n}\r\n\r\n.font-subheading {\r\n    font-size: 150%;\r\n}\r\n\r\n.vertical-middle {\r\n    vertical-align: middle;\r\n}", ""]);
// Exports
module.exports = exports;
